import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ROUTES } from "./RouteConstants";

import Home from "../pages/home/Home.jsx";
import Navbar from "../components/navbar/Navbar.jsx";
import Footer from "../components/footer/Footer.jsx";
import Contact from "../pages/contact/Contact.jsx";
import About from "../pages/about/About.jsx";
import Treatments from "../pages/treatments/Treatments.jsx";

const ReactRoute = () => {
    return (
        <BrowserRouter>
            <Navbar />
            <Routes>
                <Route path={ROUTES.home} element={<Home />} />
                <Route path={ROUTES.about} element={<About />} />
                <Route path={ROUTES.treatements} element={<Treatments />} />
                <Route path={ROUTES.contactUs} element={<Contact />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
};

export default ReactRoute;